import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { USE_PARITY } from '../../../../../constants/ebon';

import { getParityTotal } from '../../../../../utils';
import { displayableCashback, hasCashback } from '../../../../../services/partner/utils';

import FixedValueBloc from './FixedValueBloc';
import FreeValueBloc from './FreeValueBloc';

const ConfirmationEbonPageMessageBloc = ({
    partner,
    isEnterpriseCard,
    sessionEmail,
    confirmedOrder
}) => {
    const ebonDiscount = confirmedOrder && confirmedOrder.ebonDiscount;
    const ebonList = confirmedOrder && confirmedOrder.ebonList;

    const effectiveDiscount =
        ebonDiscount && (USE_PARITY ? ebonDiscount.parity : ebonDiscount.cashback);
    const fixed = effectiveDiscount && effectiveDiscount.fixed.value;
    const percent = effectiveDiscount && effectiveDiscount.percent.value;
    const amountCashback = fixed > 0 ? fixed : percent;

    const isCumulableWithCashback = ebonDiscount && ebonDiscount.cumulativeWithCashbackDiscount;
    const cumulFixed =
        partner && hasCashback(partner) && partner.mostDisplayableDiscountOnline.fixed;
    const cumulPercent =
        partner && hasCashback(partner) && partner.mostDisplayableDiscountOnline.percent;
    const cumulableCashback = displayableCashback(cumulPercent, cumulFixed);

    const doEbonListTotal = ebonList => {
        return ebonList.reduce((acc, curr) => acc + curr.facialValue, 0);
    };
    const doEbonListTotalCashbackAmount = ebonList => {
        const ebonListTotal = doEbonListTotal(ebonList);
        const totalCashbackAmount = (ebonListTotal * amountCashback) / 100;
        const normalizedCashBackNumber = +totalCashbackAmount.toFixed(2);
        return normalizedCashBackNumber;
    };
    const doEbonListTotalCashbackAmountParity = ebonList => {
        const ebonListTotal = doEbonListTotal(ebonList);
        const totalCashbackAmount = getParityTotal(ebonListTotal, amountCashback);
        const normalizedCashBackNumber = Number(totalCashbackAmount.toFixed(2));
        return normalizedCashBackNumber;
    };
    const ebonListTotalCashbackAmount = ebonList
        ? USE_PARITY
            ? doEbonListTotalCashbackAmountParity(ebonList)
            : doEbonListTotalCashbackAmount(ebonList)
        : 0;

    return ebonList && ebonList.length > 0 ? (
        <FixedValueBloc
            partner={partner}
            isEnterpriseCard={isEnterpriseCard}
            sessionEmail={sessionEmail}
            amount={ebonListTotalCashbackAmount}
            isCumulableWithCashback={isCumulableWithCashback}
            cumulableCashback={cumulableCashback}
        />
    ) : (
        <FreeValueBloc
            partner={partner}
            isEnterpriseCard={isEnterpriseCard}
            sessionEmail={sessionEmail}
            amount={ebonListTotalCashbackAmount}
            isCumulableWithCashback={isCumulableWithCashback}
            cumulableCashback={cumulableCashback}
        />
    );
};

ConfirmationEbonPageMessageBloc.propTypes = {
    partner: PropTypes.object,
    isEnterpriseCard: PropTypes.bool,
    sessionEmail: PropTypes.string,
    confirmedOrder: PropTypes.object
};

const mapStateToProps = state => {
    return {};
};

export default connect(mapStateToProps)(ConfirmationEbonPageMessageBloc);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/confirmation/message/ConfirmationEbonPageMessageBloc.js